module.exports = __webpack_public_path__ + "img/alipayhk.3bc30c65.jpeg";